import { render, staticRenderFns } from "./leyoulogin.vue?vue&type=template&id=72ae40f5&scoped=true"
import script from "./leyoulogin.vue?vue&type=script&lang=js"
export * from "./leyoulogin.vue?vue&type=script&lang=js"
import style0 from "./leyoulogin.vue?vue&type=style&index=0&id=72ae40f5&prod&lang=scss"
import style1 from "./leyoulogin.vue?vue&type=style&index=1&id=72ae40f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae40f5",
  null
  
)

export default component.exports